import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import VerifyStep from './VerifyStep';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class OpenFacebookRow extends PureComponent {
  renderButton() {
    const {
      pageLink
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary",
      size: "small",
      href: pageLink,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "MessagesApp.verifyFbmPrompt.stepOne.button"
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsx(VerifyStep, {
      button: this.renderButton(),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("span", {
          className: "is--heading-5 m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepOne.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.stepOne.body"
          })
        })]
      })
    });
  }
}
OpenFacebookRow.displayName = 'OpenFacebookRow';
export default OpenFacebookRow;